@if (quantity) {
  {{quantity}}&nbsp;
}

@if (blocksOfMetric?.metric?.name) {
  <span class="text-grey">{{'configurator.units.blocksOf' | cxTranslate}}</span>
  <span class="text-grey text-break">{{blocksOfMetricFormattedAmount}}&nbsp;{{blocksOfMetric.metric.name}}</span>
}

@if (!blocksOfMetric?.metric?.name && salesMetric?.name) {
  <span class="text-grey text-break">{{salesMetric.name}}</span>
}

@if (!blocksOfMetric?.metric?.name && !salesMetric?.name) {
  <span class="text-grey text-break">{{salesUnit}}</span>
}

@if (salesMetric?.description && tooltipToggleIsEnabled) {
  <dcp-icon-button-tooltip
    [placement]="'Right'"
    [openOnClick]="true"
    accessibleName="metricTooltip"
    data-cy="metric-tooltip">
    <span class="body--s">{{salesMetric.description}}</span>
  </dcp-icon-button-tooltip>
}
